import { useContext } from "react";

// external components
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Cookies from "universal-cookie";
import { AdminDashboardContext } from "../../../../../context/AdminDashboardContext";
import { adminUpdateProjectInfoSet } from "../../ApiRequests.js";
// style
import Style from "./ModalUpdateProjectInfo.module.css";

const ModalUpdateProjectInfo = () => {
  const {
    setModalUpdateProjectInfoIsOpen,
    handleEditable,
    updateProjectData,
    setUpdateProjectData,
    selectedProject,
    setSelectedProject,
    setProjectLocked,
    setEditingInProgress,
    setLoadingSpinnerIsOpen,
    setModalMessageNoReloadIsOpen,
    setMessageForNoReloadModal,
  } = useContext(AdminDashboardContext);

  const handleYesButton = async () => {
    const username = new Cookies(null, { path: "/" }).get("username");
    handleEditable();
    setModalUpdateProjectInfoIsOpen(false);

    setProjectLocked(true);
    setEditingInProgress(false);

    if (!isEmptyObject(updateProjectData) && selectedProject?.id) {
      setLoadingSpinnerIsOpen(true);

      const check = await adminUpdateProjectInfoSet(
        selectedProject?.id,
        updateProjectData,
        username
      );

      if (check) {
        setSelectedProject({ ...selectedProject, ...updateProjectData });
        setUpdateProjectData({});
        setLoadingSpinnerIsOpen(false);

        setMessageForNoReloadModal("Projekt uspješno ažuriran!");
        setModalMessageNoReloadIsOpen(true);
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      }
    }
  };

  const handleNoButton = () => {
    setModalUpdateProjectInfoIsOpen(false);
  };

  const closeModal = () => {
    setModalUpdateProjectInfoIsOpen(false);
  };

  function isEmptyObject(obj) {
    return JSON.stringify(obj) === "{}";
  }

  return (
    <div className={Style.ModalContainerOverlay}>
      <div className={Style.Modal}>
        <div className={Style.ModalTopContainer}>
          <button className={Style.ModalClose} onClick={() => closeModal()}>
            <FontAwesomeIcon icon={faXmark} size="1x" />
          </button>
          <h3 className={Style.ModalQuestion}>Završi uređivanje dokumenta?</h3>
        </div>

        <div className={Style.ModalButtonsContainer}>
          <button
            onClick={() => handleYesButton()}
            className={Style.ModalButton}
          >
            DA
          </button>
          <button
            onClick={() => handleNoButton()}
            className={Style.ModalButton}
          >
            NE
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalUpdateProjectInfo;
